import { Paper, Typography, Button, Pagination } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useState } from "react";
import { AdminButton, TableMui } from "../../components/mui";
import { Box, IconButton, InputBase } from "@mui/material";
import { Search } from "@mui/icons-material";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { useEffect } from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import { Link, Navigate, useNavigate } from "react-router-dom";

let limit = 10;
const BlogsDashboard = ({ role }) => {
  // const [count,setCount]=useState(0)
  // const [blogs,setBlogs]=useState()
  // const [loading, setLoading] = useState(false);

  // const {data,error,request}=useApi((endpoint)=>apiClient.get(endpoint))
  const navigate = useNavigate();
  // const [offset,setOffset]=useState(0)

  // let Endpoint = `blogs/?limit=${limit}&offset=`;
  // useEffect(()=>{
  //   fetchData(Endpoint+offset)
  // },[])
  // const fetchData = async (endpoint) => {
  //   setLoading(true)
  //  const response= await request(endpoint)
  //  if(error)
  //  return
  // if(!count)
  // setCount(response.data.count)
  // const afterTrimming = trimDates(response.data.results, "created_at");

  // afterTrimming && setBlogs(afterTrimming);
  // setLoading(false)

  // }

  // const handlePageChange = (event,value) => {

  //   value=((value - 1) * limit)
  //   fetchData(Endpoint+value)
  //   setOffset(value)

  // }

  const roles = ["super admin", "admin", "viewer"];
  const data = [
    {
      name: "John Doe",
      email: "john.doe@example.com",
      role: "User",
      location: "New York",
    },
    {
      name: "Jane Smith",
      email: "jane.smith@example.com",
      role: "Advertiser",
      location: null,
    },
    {
      name: "Bob Johnson",
      email: "bob.johnson@example.com",
      role: "Corporation",
      location: null,
    },
    {
      name: "Alice Brown",
      email: "alice.brown@example.com",
      role: "Driver",
      location: "San Francisco",
    },
    {
      name: "Alice Brown",
      email: "alice.brown@example.com",
      role: "Installer",
      location: "San Francisco",
    },
    {
      name: "Alice Brown",
      email: "alice.brown@example.com",
      role: "Photographer",
      location: "San Francisco",
    },
  ];

  for (let i = 0; i < 30; i++) {
    const randomIndex = Math.floor(Math.random() * roles.length);
    const randomRole = roles[randomIndex];

    const obj = {
      name: "Person " + (i + 1),

      email: i + 1 + "@example.com",
      role: randomRole,
    };

    data.push(obj);
  }

  console.log(data);

  const users = role !== "Team" ? data.filter((x) => x.role == role) : data;
  useEffect(() => {
    document.title = "RollingAdz: User" || "Default Title";
  }, []);
  return (
    <Box component={Paper} sx={{ marginBottom: "20px", padding: "20px" }}>
      <div className="container d-flex justify-content-between">
        <div
          className=" d-flex justify-content-between align-items-center px-4 col-md-6"
          style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
        >
          <InputBase
            className=""
            sx={{
              ml: 1,
              flex: 1,
              px: 1,
            }}
            placeholder="Search..."
            type="search"
          />
          <Box
            sx={{
              width: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
            }}
          >
            <IconButton
              type="button"
              sx={{
                p: "5px",
                backgroundColor: "#3E4755",
                color: "white",
                "&:hover": {
                  backgroundColor: "#3E4755",
                  color: "white",
                },
              }}
              aria-label="search"
            >
              <Search style={{ fontSize: 25 }} />
            </IconButton>
          </Box>
        </div>
        <div>
          <AdminButton
            onClick={() => {
              role === "Team"
                ? navigate("/admin/add-team")
                : navigate("/admin/add-user");
            }}
            name="Add New"
          />
        </div>
      </div>

      <Typography variant="h5" sx={{ marginBottom: "10px" }}>
        Team
      </Typography>
      <Box>
        <TableMui
          styleTableTh={{ fontWeight: "bold", whiteSpace: "nowrap" }}
          //   loading={loading}
          th={{
            name: (
              <>
                Name <FilterAltOutlinedIcon />
              </>
            ),
            email: (
              <>
                Email <FilterAltOutlinedIcon />
              </>
            ),
            role: (
              <>
                Role <FilterAltOutlinedIcon />
              </>
            ),
            location:
              role !== "Advertiser" && role !== "Corporation" ? (
                <>
                  Location <FilterAltOutlinedIcon />
                </>
              ) : null,
          }}
          td={users}
          customBtn={(row) => <CustomBtn row={row} role={users.role} />}
        />
      </Box>

      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </Box>
  );
};
function CustomBtn({ row }) {
  console.log(row);
  const navigate = useNavigate();

  const blogDetail = (item) => {
    console.log(item.role, "nassjajhdajhdsa");
    if (item.role === "Installer") {
      navigate("/installeraccount");
    } else if (item.role === "Advertiser") {
      navigate("/advertiser-account");
    } else if (item.role === "Photographer") {
      navigate("/photograperaccount");
    } else if (item.role === "Vehicle Owner") {
      navigate("/vehicleowneraccount");
    } else if (item.role === "DesignerAccount") {
      navigate("/designeraccount");
    }
  };

  function edit() {
    navigate("/admin/add-user", { state: "Update" });
  }

  const handleDelete = async (id) => {
    const response = window.confirm(
      "Are you sure you want to delete this user?"
    );
    //  const response= await apiClient.delete(`blog/${id}/`)
    //  if(response.status!=204)
    //  return
    //  else{
    //   fetchData(Endpoint+offset)
    //    alert('deleted success fully')

    //  }
  };

  return (
    <div className="d-flex gap-3 justify-content-center">
      <AdminButton onClick={() => edit()} name="Edit" />

      <AdminButton onClick={() => navigate("/chat")} name="Message" />

      <AdminButton
        className="btn btn-danger"
        style={{
          backgroundColor: "red",
          "&:hover": { backgroundColor: "#e32636" },
        }}
        onClick={() => handleDelete(row.id)}
        name="Delete"
      />
    </div>
  );
}

export default BlogsDashboard;
